module.exports = __webpack_public_path__ + "img/buy-car768x432.50a84483.png";